
import ReviewsViewLazyImage from './LazyImage.vue';

export default {
  name: 'ReviewsViewBanner',
  components: {
    ReviewsViewLazyImage,
  },
  props: {
    bannerData: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      isImgLoaded: new Array(1).fill(false),
      imageUrl: '/skin/frontend/onestopbedrooms/default/images/review-icon',
      imageUrlM: '/skin/frontend/onestopbedrooms/default/images/review',
    };
  },
  methods: {
    load(index) {
      this.$set(this.isImgLoaded, index, true);
    },
  },
};
